export enum ImageType {
  Product = "Product",
  ProductVariant = "ProductVariant",
  ProductCategory = "ProductCategory",
  VariantOptionValue = "VariantOptionValue",
}
